/**
 * Musica de fondo de los menus (Online/Privado/lobby), nunca durante el
 * partido. Vive aparte de `audio.ts` a proposito: los SFX del partido son
 * sintetizados con Web Audio (cero assets externos); esto es el unico asset
 * de audio real del proyecto, y solo suena fuera del campo.
 *
 * "Syncopated Groove", la que eligio el usuario el 2026-09-27. Llego como
 * Opus dentro de .m4a, que Safari no lee de forma fiable: va en MP3 (VBR,
 * ~122 kbps). El nombre del fichero es nuevo a proposito: con el mismo, la
 * cache de quien ya habia entrado seguiria sirviendo la cancion vieja.
 */
const TRACK_URL = "/audio/menu-groove.mp3";
const STORAGE_KEY = "golazo.menuMusic";

export interface MenuMusic {
  /** Empieza a sonar (o reanuda) si los menus estan visibles y la musica activa. */
  play(): void;
  /** Para en seco al entrar a un partido. */
  stop(): void;
  isEnabled(): boolean;
  setEnabled(on: boolean): void;
  dispose(): void;
}

function loadEnabled(): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === "0" || raw === "false") return false;
    if (raw === "1" || raw === "true") return true;
  } catch {
    // ignore quota / private mode
  }
  return true;
}

function saveEnabled(on: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, on ? "1" : "0");
  } catch {
    // ignore
  }
}

export function createMenuMusic(): MenuMusic {
  const el = new Audio(TRACK_URL);
  el.loop = true;
  el.volume = 0.35;
  el.preload = "auto";
  let enabled = loadEnabled();

  return {
    play(): void {
      if (!enabled) return;
      // El autoplay del navegador exige gesto del usuario; si la promesa
      // rechaza (sin gesto todavia), no pasa nada, se reintenta en el
      // siguiente `play()` (p.ej. al volver de un partido).
      void el.play().catch(() => {});
    },
    stop(): void {
      el.pause();
      el.currentTime = 0;
    },
    isEnabled(): boolean {
      return enabled;
    },
    setEnabled(on: boolean): void {
      enabled = on;
      saveEnabled(on);
      if (on) {
        void el.play().catch(() => {});
      } else {
        el.pause();
      }
    },
    dispose(): void {
      el.pause();
      el.src = "";
    },
  };
}
